import { render, staticRenderFns } from "./ComplianceFormList.vue?vue&type=template&id=0c327ffd&"
import script from "./ComplianceFormList.vue?vue&type=script&lang=js&"
export * from "./ComplianceFormList.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceFormList.vue?vue&type=style&index=0&id=0c327ffd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports